<template>
  <div
    ref="el"
    :class="['scroll-container', props.noPaddingBottom || isPrint ? '':'-padding-bottom']"
  >
    <slot />
  </div>
</template>

<script setup>
import usePrintMode from '@/composables/export/print-mode';
import { ref } from 'vue';

const props = defineProps({
  noPaddingBottom: {
    type: Boolean,
    default: false,
  },
});
const { isPrint } = usePrintMode();

const el = ref(null);
defineExpose({ el });
</script>

<style
    scoped
    lang="scss"
    type="text/scss"
>
  .scroll-container {
    position: relative;
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    height: 100%;
    overflow: auto;
    transition: width 0.2s ease-in-out;

    &.-padding-bottom {
      padding-bottom: 30vh;
    }
  }
</style>
